import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import * as styles from "./header.module.css";

import React from "react";
import { Navbar, Nav, Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Header = () => {
  return (
    <>
      <style type="text/css">
        {`
          .navbar-flat {
            background-color: white;
          }
          .link-black {
            color: #17254d;
          }
          .revert{
          }
          @media (min-width: 768px) {
            .revert{
              flex: revert;

            }
          }
          `}
      </style>
      <Navbar
        style={{
          paddingBottom: "2px",
        }}
        sticky="top"
        expand="md"
        variant="flat"
      >
        <Container>
          <Navbar.Brand href="/" style={{ marginRight: "130px" }}>
            <StaticImage
              className={styles.logo}
              src="../../images/v2/topNavbar/Logo CASHAMmdpi.png"
              layout="constrained"
              alt="Principal"
              width={150}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="revert">
            <Nav>
              <Nav.Link href="/casham-prime" className="top-nav-bar">
                Casham Prime
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link href="/casham-corporativo" className="top-nav-bar">
                Casham Corporativo
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link href="/company-invitations" className="top-nav-bar">
                Empleados
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link
                className="top-nav-bar"
                target="_blank"
                rel="noopener noreferrer"
                href="https://companies.casham.app/"
              >
                Login Empresas
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link
                className="top-nav-bar"
                target="_blank"
                rel="noopener noreferrer"
                href="https://denarium.casham.app/"
              >
                Denarium by Casham
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
